import injectReducer from 'utils/injectReducer';
import injectSaga from 'utils/injectSaga';

import reducer from './reducer';
import saga from './saga';

const withQuotationReducer = injectReducer({ key: 'quotations', reducer });
const withQuotationSaga = injectSaga({ key: 'quotations', saga });

export { withQuotationSaga, withQuotationReducer };
